var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.154,
    height: 48.153,
    viewBox: "0 0 48.154 48.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55536",
    "data-name": "Group 55536",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85394",
    "data-name": "Path 85394",
    d: "M30.1,26.087a2.006,2.006,0,0,0-2.006,2.006v8.026a2.008,2.008,0,0,1-2.007,2.006H20.064V8.029a4.044,4.044,0,0,0-2.733-3.814l-.594-.2h9.346A2.009,2.009,0,0,1,28.09,6.023v6.019a2.006,2.006,0,1,0,4.013,0V6.023A6.027,6.027,0,0,0,26.083,0H4.514A1.576,1.576,0,0,0,4.3.048C4.2.04,4.111,0,4.013,0A4.017,4.017,0,0,0,0,4.016V40.131a4.044,4.044,0,0,0,2.733,3.814l12.075,4.025a4.154,4.154,0,0,0,1.244.187,4.017,4.017,0,0,0,4.013-4.013V42.138h6.019A6.027,6.027,0,0,0,32.1,36.119V28.093A2.006,2.006,0,0,0,30.1,26.087Zm0,0",
    transform: "translate(0 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85395",
    "data-name": "Path 85395",
    d: "M298.815,115.279l-8.026-8.025a2.006,2.006,0,0,0-3.425,1.418v6.019h-8.025a2.006,2.006,0,1,0,0,4.013h8.025v6.019a2.006,2.006,0,0,0,3.425,1.419l8.026-8.026A2,2,0,0,0,298.815,115.279Zm0,0",
    transform: "translate(-251.249 -96.634)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.641438dad67ba2d8ac60ff46127e71e8.svg";
export { ForwardRef as ReactComponent };